import React from 'react';

const SocialFacebook = () => {
  return (
    <svg id="elements_social-facebook.svg" data-name="elements/social-facebook.svg" xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 60 60">
      <path className="cls-1 bgFill" d="M4332,1870a30,30,0,1,1-30-30A30,30,0,0,1,4332,1870Z" transform="translate(-4272 -1840)" />
      <path className="cls-2 innerFill" d="M4304.36,1887.6v-16.43h5.52l0.83-6.4h-6.35v-4.08c0-1.86.51-3.12,3.17-3.12h3.4v-5.73a45.163,45.163,0,0,0-4.95-.25c-4.9,0-8.25,2.98-8.25,8.46v4.72h-5.54v6.4h5.54v16.43h6.63Z" transform="translate(-4272 -1840)" />
    </svg>
  );
};

export default SocialFacebook;
